import React, { useContext } from 'react';

import { useValidatedProgramPromotionInternal } from './UseValidatedProgramPromotion';

type ValidatedProgramPromotionContext = ReturnType<typeof useValidatedProgramPromotionInternal>;

const initialContext: ValidatedProgramPromotionContext = {
  programPromotion: undefined,
  isProgramPromoLoading: false,
};

const ValidatedProgramPromotion = React.createContext<ValidatedProgramPromotionContext>(initialContext);
ValidatedProgramPromotion.displayName = 'ValidatedProgramPromotion';

export const useValidatedProgramPromotion = () => useContext(ValidatedProgramPromotion);

export const ValidatedProgramPromotionProvider: React.FC = ({ children }) => {
  return (
    <ValidatedProgramPromotion.Provider value={useValidatedProgramPromotionInternal()}>
      {children}
    </ValidatedProgramPromotion.Provider>
  );
};

export const ValidatedProgramPromotionConsumer = ValidatedProgramPromotion.Consumer;
